import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

import { SplashScreenButton } from './SplashScreenButton';
import type { SplashScreenAction } from './types/splash-screen-action.type';

interface Props {
  readonly illustration: ReactNode;
  readonly message: ReactNode;
  readonly action?: SplashScreenAction;
  readonly children?: ReactNode;
}

export const SplashScreen = ({
  illustration,
  message,
  action,
  children,
}: Readonly<Props>) => (
  <Box
    sx={{
      // The splash screen takes the free space of its flex parent (a tab
      // panel row, a page column under its title) to centre its content; alone
      // in a block parent, its whole height.
      flexGrow: 1,
      alignSelf: 'stretch',
      '&:only-child': { minHeight: '100%' },
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
    }}
  >
    {/* The illustrations centre themselves with auto margins: in this flex
        column they would take the free height, pushing the message down. */}
    <Box>{illustration}</Box>
    <Typography component="div" gutterBottom variant="body1">
      {message}
    </Typography>
    {!!action && <SplashScreenButton action={action} />}
    {children}
  </Box>
);
